import React, { useEffect, useState } from "react";
import { HashRouter as Router, Route } from "react-router-dom";
import { Switch } from "react-router-dom";
import Login from "./authentication/Login";
import ProtectedRoute from "./authentication/ProtectedRoute";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

// component
import Dashboard from "./main/dashboard/Index";
import Profile from "./main/profile/Profile";
import AllUserDetails from "./main/user/UserDetails";
import NotificationPage from "./main/notification/notification";
import StickySidebar from "./layouts/StickySidebar";
import Page404 from "./pages/errorpages/404";
import UserRegister from "./main/user/UserRegister";
import AllMasterDetails from "./main/Master/MasterDetails";
import MasterRegister from "./main/Master/MasterRegister";
import userDelete from "./main/user/userDelete";

const AppContainer = () => {
  const [user, setUser] = useState();

  function getBrowserInfo() {
    return {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      screenResolution: window.screen.width + "x" + window.screen.height,
      colorDepth: window.screen.colorDepth,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      touchSupport: navigator.maxTouchPoints > 0,
      hardwareConcurrency: navigator.hardwareConcurrency,
      deviceMemory: navigator.deviceMemory || "unknown",
    };
  }

  const generateBrowserId = () => {
    const info = getBrowserInfo();
    const infoString = JSON.stringify(info);
    let hash = 0;
    for (let i = 0; i < infoString.length; i++) {
      const char = infoString.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0;
    }
    return "browser-" + Math.abs(hash).toString(36);
  };

  useEffect(() => {
    console.log = function() {};
    const browserId = generateBrowserId();
    console.log("User's browser ID:", browserId);
    const browserInfo = getBrowserInfo();
    console.log(browserInfo);
    const user = localStorage.getItem("user") || null;
    setUser(user);
  }, []);

  return (
    <Router basename="/">
      {user && user !== null && (
        <Route
          path={["/dashboard", "/profile", "/user", "/notification"]}
          render={() => <StickySidebar />}
        />
      )}
      <Switch>
        <Route path="/login" exact component={Login} />
        <Route path="/" exact component={RootRouter} />
        <Route path="/user_dele" exact component={userDelete} />
        <ProtectedRoute path="/dashboard" component={Dashboard} />
        <ProtectedRoute path="/profile" component={Profile} />
        <ProtectedRoute path="/user" component={AllUserDetails} />
        <ProtectedRoute path="/notification" component={NotificationPage} />
        <ProtectedRoute path="/useregister" component={UserRegister} />
        <ProtectedRoute path="/master" component={AllMasterDetails} />
        <ProtectedRoute path="/masterregister" component={MasterRegister} />
        <Route path="*" component={Page404} />
      </Switch>
    </Router>
  );
};

export default AppContainer;

// RootRouter
function RootRouter() {
  const history = useHistory();

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      history.push("/dashboard");
    } else {
      history.push("/login");
    }
  }, [history]);

  return <p>CEN POILT</p>;
}
